import {IMAGE_URL_BASE} from "../constants";
import {LOCK_STATUS_ACTIVE} from "../constants";
import {LOCK_STATUS_INACTIVE} from "../constants";

export default {
  data: () => ({
    base: IMAGE_URL_BASE,
    status: {
      lock: {
        active: LOCK_STATUS_ACTIVE,
        inactive: LOCK_STATUS_INACTIVE,
      }
    }
  })
}
